export const ALERT_INITIAL_STATE = {
  title: '',
  text: '',
  show: false,
  variation: '',
  duration: 3000,
  iconName: '',
};
